import {
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import './App.css';
import MasseuseContainerDesktop from './components/MasseuseContainerDesktop';
import MasseuseContainerMobile from './components/MasseuseContainerMobile';
import theme from './components/Theme';
import useDropdownChoices from './hooks/useDropdownChoices';
import useMasseuses from './hooks/useMasseuses';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import HoverCard from './components/HoverCard';
import ThumbnailDetailsDialog from './components/ThumbnailDetailsDialog';
import useAvailableMasseusesSlots from './hooks/useAvailableMasseusesSlots';

function App() {
  const [bust_enhanced, setBust_enhanced] = useState('');
  const [services, setServices] = useState('');
  const [newMasseuse, setNewMasseuse] = useState('');
  const [background, setBackground] = useState('');
  const [available_on, setAvailable_on] = useState(isMobile ? 'today' : '');
  const [hair_color, setHair_color] = useState('');
  const [technique, setTechnique] = useState('');

  const [view, setView] = useState('list');
  const [selectedThumbnailMasseuseId, setSelectedThumbnailMasseuseId] =
    useState(null);

  const handleViewChange = (event, nextView) => {
    if (!nextView) {
      return;
    }

    setView(nextView);

    if (nextView !== 'thumbnail') {
      setSelectedThumbnailMasseuseId(null);
    }
  };

  const [dropdowns, dropdownsLoading] = useDropdownChoices();
  const backgrounds = dropdowns ? dropdowns?.backgrounds : [];
  const hairColors = dropdowns ? dropdowns?.hairColors : [];

  const { data, isLoading } = useMasseuses({
    page: 1,
    page_size: 1000,
    bust_enhanced,
    services,
    newMasseuse,
    language: '',
    tattoos: '',
    available_on,
    hair_color,
    background,
    technique,
  });

  const { availableMasseusesSlots } = useAvailableMasseusesSlots(60000);

  const handleToggleChange = (event, value) => {
    if (value === 'today') {
      setAvailable_on(value);
      setNewMasseuse('');
    } else if (value === 'tomorrow') {
      setAvailable_on(value);
      setNewMasseuse('');
    } else if (value === 'new') {
      setNewMasseuse('true');
      setAvailable_on('');
    } else if (value === 'all') {
      setAvailable_on('');
      setNewMasseuse('');
    }
  };

  const selectedThumbnailMasseuse =
    data?.find((masseuse) => masseuse.id === selectedThumbnailMasseuseId) ||
    null;

  return (
    <div style={{ minHeight: '80vh' }}>
      <ThemeProvider theme={theme}>
        <Container maxWidth={'md'} style={{ marginBottom: '-20px' }}>
          <Grid container spacing={1} marginTop={1} alignItems="center">
            <Grid item xs={12} sm={12}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                {!isMobile && (
                  <ToggleButtonGroup
                    orientation="horizontal"
                    value={view}
                    exclusive
                    onChange={handleViewChange}
                  >
                    <ToggleButton
                      value="thumbnail"
                      aria-label="thumbnail"
                      color="primary"
                    >
                      <ViewModuleIcon
                        color={view === 'thumbnail' ? 'primary' : ''}
                      />
                      &nbsp; Thumbnail View
                    </ToggleButton>
                    <ToggleButton value="list" aria-label="list">
                      <ViewListIcon color={view === 'list' ? 'primary' : ''} />{' '}
                      &nbsp; Detailed View
                    </ToggleButton>
                  </ToggleButtonGroup>
                )}
                &nbsp;
                <Button
                  disableElevation
                  onClick={(e) => handleToggleChange(e, 'today')}
                  variant={available_on === 'today' ? 'contained' : 'outlined'}
                >
                  Today
                </Button>
                &nbsp;
                <Button
                  disableElevation
                  onClick={(e) => handleToggleChange(e, 'tomorrow')}
                  variant={
                    available_on === 'tomorrow' ? 'contained' : 'outlined'
                  }
                  size={isMobile ? 'small' : 'medium'}
                >
                  Tomorrow
                </Button>
                &nbsp;
                <Button
                  disableElevation
                  onClick={(e) => handleToggleChange(e, 'new')}
                  variant={newMasseuse.length > 0 ? 'contained' : 'outlined'}
                >
                  New
                </Button>
                &nbsp;
                <Button
                  disableElevation
                  onClick={(e) => handleToggleChange(e, 'all')}
                  variant={
                    available_on.length === 0 && newMasseuse.length === 0
                      ? 'contained'
                      : 'outlined'
                  }
                >
                  All
                </Button>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  marginTop: '5px',
                }}
              >
                <small style={{ textAlign: 'right' }}>
                  To see today's available masseuses click the "Today" tab
                  above.
                </small>
              </div>
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <FormControl fullWidth size="small">
                <InputLabel id="select-technique">Technique</InputLabel>
                <Select
                  labelId="select-technique"
                  value={technique}
                  label="Technique"
                  onChange={(e) => setTechnique(e.target.value)}
                >
                  <MenuItem value={''}>No selection</MenuItem>
                  <MenuItem value={'Sensual'}>Sensual</MenuItem>
                  <MenuItem value={'Shiatsu'}>Shiatsu</MenuItem>
                </Select>{' '}
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <FormControl fullWidth size="small">
                <InputLabel id="select-bust-type">Bust</InputLabel>
                <Select
                  labelId="select-bust-type"
                  value={bust_enhanced}
                  label="Bust"
                  onChange={(e) => setBust_enhanced(e.target.value)}
                >
                  <MenuItem size="small" value={''}>
                    No selection
                  </MenuItem>
                  <MenuItem value={'true'}>Enhanced</MenuItem>
                  <MenuItem value={'false'}>Natural</MenuItem>
                </Select>{' '}
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <FormControl fullWidth size="small">
                <InputLabel id="select-language">Services</InputLabel>
                <Select
                  labelId="select-language"
                  value={services}
                  label="Services"
                  onChange={(e) => setServices(e.target.value)}
                >
                  <MenuItem size="small" value={''}>
                    No selection
                  </MenuItem>
                  <MenuItem value={'men'}>Men</MenuItem>
                  <MenuItem value={'both'}>Men & Women</MenuItem>
                </Select>{' '}
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={2.4}>
              <FormControl fullWidth size="small">
                <InputLabel id="select-hair-color">Hair Color</InputLabel>
                <Select
                  labelId="select-hair-color"
                  value={hair_color}
                  disabled={dropdownsLoading ? true : false}
                  label="Hair Color"
                  onChange={(e) => setHair_color(e.target.value)}
                >
                  <MenuItem size="small" value={''}>
                    No selection
                  </MenuItem>
                  {!dropdownsLoading &&
                    hairColors?.map((h) => (
                      <MenuItem size="small" value={h} key={h}>
                        {h}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <FormControl fullWidth size="small">
                <InputLabel id="select-background">Background</InputLabel>
                <Select
                  labelId="select-background"
                  value={background}
                  disabled={dropdownsLoading ? true : false}
                  label="Background"
                  onChange={(e) => setBackground(e.target.value)}
                >
                  <MenuItem size="small" value={''}>
                    No selection
                  </MenuItem>
                  {!dropdownsLoading &&
                    backgrounds?.map((b) => (
                      <MenuItem size="small" value={b} key={b}>
                        {b}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} style={{ height: '10px' }}>
              {isLoading && <LinearProgress />}
            </Grid>
          </Grid>
        </Container>
        {!isLoading && !isMobile && view === 'thumbnail' && (
          <Container maxWidth={'lg'}>
            <Grid container spacing={1} mt={6}>
              {data?.map((masseuse, index) => (
                <HoverCard
                  key={index}
                  masseuse={masseuse}
                  onOpenDetails={() =>
                    setSelectedThumbnailMasseuseId(masseuse.id)
                  }
                />
              ))}
            </Grid>
          </Container>
        )}
        <Container style={{ width: '100%', marginTop: '25px' }} maxWidth={'md'}>
          {!isLoading &&
            isMobile &&
            data.map((masseuse, index) => (
              <MasseuseContainerMobile
                masseuse={masseuse}
                key={masseuse.id}
                index={index}
                slots={availableMasseusesSlots}
                available_on={available_on}
              />
            ))}

          {/* Load masseuse container optimized for desktop */}
          {!isLoading &&
            !isMobile &&
            view === 'list' &&
            data.map((masseuse, index) => (
              <MasseuseContainerDesktop
                masseuse={masseuse}
                key={masseuse.id}
                slots={availableMasseusesSlots}
                available_on={available_on}
              />
            ))}

          {!isLoading && data && data.length === 0 && (
            <p style={{ marginTop: '20px' }}>
              No masseuses found, try changing the filters
            </p>
          )}
        </Container>
        <ThumbnailDetailsDialog
          open={Boolean(selectedThumbnailMasseuse)}
          masseuse={selectedThumbnailMasseuse}
          onClose={() => setSelectedThumbnailMasseuseId(null)}
          slots={availableMasseusesSlots}
          available_on={available_on}
        />
      </ThemeProvider>
    </div>
  );
}

export default App;
